import {
    DST_PRODUCT_DETAIL_LABELS,
    DstProductDetailLabels,
} from "../utils/productDetailLabels";

export interface UseDstProductDetailLabelsResult {
    labelsLoaded: boolean;
    labels: DstProductDetailLabels;
}

export const useDstProductDetailLabels =
    (): UseDstProductDetailLabelsResult => ({
        labelsLoaded: true,
        labels: DST_PRODUCT_DETAIL_LABELS,
    });
